'use client';

import React, { useState } from 'react';
import { App, Form, Input, Modal } from 'antd';
import { requestCreateCustomized } from '@/lib/api/customized';

type FormValues = {
  content: string;
  contact_way: string;
};

export default function CustomizedModel() {
  const { message } = App.useApp();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm<FormValues>();

  const handleSubmit = async (values: FormValues) => {
    try {
      setLoading(true);
      const res = await requestCreateCustomized({
        content: values.content,
        contact_way: values.contact_way,
        type: 1,
      });
      if (res.code === 200) {
        console.log(res, 'res');
        
        message.success('提交成功，我们会尽快与您联系');
        form.resetFields();
        setOpen(false);
      } else {
        message.error(res.message || '提交失败');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="bg-[#f58323] px-2 h-[40px] text-white c-flex mr-6 cursor-pointer !text-[10px]"
        onClick={() => setOpen(true)}
      >
        定制咨询
      </div>
      <Modal
        title="定制咨询"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => form.submit()}
        confirmLoading={loading}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="联系方式"
            name="contact_way"
            rules={[{ required: true, message: '请输入联系方式' }]}
          >
            <Input placeholder="邮箱" />
          </Form.Item>
          <Form.Item
            label="询盘内容"
            name="content"
            rules={[{ required: true, message: '请输入询盘内容' }]}
          >
            <Input.TextArea rows={4} placeholder="请描述您的定制需求" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
